export const API_URL = import.meta.env.VITE_API_ENDPOINT

export const LOGIN_ROUTE = '/login'
export const LOGOUT_ROUTE = '/logout'
export const RESET_PASSWORD_ROUTE = '/reset-password'
export const UPDATE_PASSWORD_ROUTE = '/update-password'
export const ORGANIZATION_LOOKUP_ROUTE = '/orgs/lookup'
export const DEVICES_ROUTE = '/orgs'
export const ANDROID_DEVICE_ROUTE = '/orgs/devices/android'
export const ENROLLED_DEVICE_ROUTE = '/orgs/devices/enrolled'
export const UNENROLLED_DEVICE_ROUTE = '/orgs/devices/unenrolled'
export const INSECURE_DEVICE_ROUTE = '/orgs/devices/insecure'
export const DEVICE_DETAILS_ROUTE = '/orgs/devices/device-details'
export const DEVICE_ALERTS_ROUTE = '/orgs/devices/device-alerts'
export const DEVICE_SCANS_ROUTE = '/orgs/devices/device-scans'
export const DEVICE_EVENTS_ROUTE = '/orgs/devices/device-events'
export const DEVICE_FORENSICS_ROUTE = '/orgs/devices/device-forensics'
export const DEVICE_FILE_EVENTS_ROUTE = '/orgs/devices/device-events-for-file'
export const SUPPORTED_IOS_VERSIONS_ROUTE = '/orgs/supported-ios-versions'

export const ALERTS_ROUTE = '/v2/alerts'
export const ALERTS_CLOSE_ROUTE = '/close-alerts'
export const SESSION_ROUTE = '/session'
export const EMAIL_USERS_ROUTE = '/orgs/email-members'
export const UNENROLL_DEVICES_ROUTE = '/orgs/unenroll-devices'
export const UPDATE_DEVICE_NAME_ROUTE = '/orgs/device-name'
export const ALERT_REPORT_ROUTE = '/alerts/report'
export const ALERT_DETAILS_ROUTE = '/alert-details'
export const ALERT_SIMULATE_ROUTE = '/orgs/alert-sim'

export const DASHBOARD_STATS_ROUTE = '/orgs/dashboard/stats'
export const DASHBOARD_DEVICES_CREATED_STAT_ROUTE = '/orgs/dashboard/devices-created'
export const DASHBOARD_ALERTS_CREATED_STAT_ROUTE = '/orgs/dashboard/alerts-created'
export const DASHBOARD_TOTAL_SCANS_STAT_ROUTE = '/orgs/dashboard/total-scans'
export const DASHBOARD_INSECURE_DEVICES_STAT_ROUTE = '/orgs/dashboard/insecure-devices'

export const DEVICE_FLEET_STATS_ROUTE = '/orgs/device-fleet-stats'
export const RISK_STATS_ROUTE = '/orgs/risk-stats'

export const MEMBERS_ROUTE = '/orgs/members'
export const ADD_MEMBERS_ROUTE = '/orgs/create-members?email=true'
export const UNBLOCK_MEMBERS_ROUTE = '/orgs/conditional-access/unblock-member'
export const REMOVE_MEMBER_ROUTE = '/orgs/remove-member'
export const REMOVE_GRACE_PERIOD_ROUTE = '/orgs/conditional-access/remove-grace-period'
export const ADMINS_ROUTE = '/orgs/admins'
export const RESEND_INVITE_ADMIN_ROUTE = '/orgs/resend-admin-invite'
export const ADD_ADMIN_ROUTE = '/orgs/add-admin'
export const UPDATE_ADMIN_ROUTE = '/orgs/update-admin'
export const DELETE_ADMIN_ROUTE = '/orgs/delete-admin'
export const SSO_ROUTE = '/orgs/sso'
export const AUDIT_ROUTE = '/orgs/audit-logs'

export const GET_DOMAIN_BLOCKLIST_ROUTE = '/orgs/dns-blocked-list'
export const GET_DOMAIN_BLOCKLIST_LOGS_ROUTE = '/orgs/dns-blocked-list-logs'
export const POST_DOMAIN_TO_BLOCKLIST_ROUTE = '/orgs/update-dns-blocked-list'
export const DELETE_BLOCKED_DOMAIN_ROUTE = '/orgs/delete-blocked-domain'

export const GET_INTEGRATIONS_ROUTE = '/orgs/integrations-list'
export const UPDATE_INTEGRATION_CONFIG_ROUTE = '/orgs/configure-integration'
export const UPDATE_IVRIFY_INTEGRATION_CONFIG_ROUTE = '/orgs/configure-iverify-options'
export const DELETE_INTEGRATION_ROUTE = '/orgs/delete-integration'

export const API_ROUTE = '/api/token'
export const WEBHOOK_ROUTE = '/orgs/webhook'
export const WEBHOOK_SECRET_ROUTE = '/orgs/webhook-secret'
export const SCIM_ROUTE = '/orgs/scim'
export const SCIM_ENABLED_ROUTE = '/orgs/scim-enabled'
export const MDM_ROUTE = '/orgs/mdm'
export const EMAIL_PREFERENCES_ROUTE = '/orgs/email-preferences'
export const NOTIFICATION_PREFERENCES_ROUTE = '/orgs/notifications-preferences?topic=OpenAppToScan'
export const CUSTOM_DNS_ROUTE = '/orgs/custom-dns'
export const ENROLLMENT_EMAIL_TEMPLATE_ROUTE = '/orgs/email-template?type=OrgEnrollment'
export const PUT_ENROLLMENT_EMAIL_TEMPLATE_ROUTE = '/orgs/email-template'
export const THREAT_HUNTER_USERS_ROUTE = '/threat-hunter/users'
export const ADD_THREAT_HUNTER_USER_ROUTE = '/threat-hunter/user'
export const CONDITIONAL_ACCESS_CONFIG_ROUTE = '/orgs/conditional-access/config'
export const CONDITIONAL_ACCESS_STATUS_ROUTE = '/orgs/conditional-access/status'
export const MTD_STATUS_ROUTE = '/orgs/mtd/status'
export const DEVICE_POLICIES_ROUTE = '/orgs/device-policies'
export const DEVICE_POLICY_ROUTE = '/orgs/device-policy'
export const DEVICE_POLICY_UPDATE_ROUTE = '/orgs/update-device-policy'
export const DEVICE_POLICY_CREATE_ROUTE = '/orgs/create-device-policy'
export const DEVICE_POLICY_UPDATE_NAME_ROUTE = '/orgs/device-policy-name'
export const CONDITIONAL_ACCESS_DELETE_ROUTE = '/orgs/conditional-access'
export const THREAT_HUNTER_SCAN_ACTIVITY_ROUTE = '/orgs/threat-hunter-scan-activity'
export const DEVICE_SCAN_ACTIVITY_ROUTE = '/orgs/device-scan-activity'

export const EDR_SCAN_DETAILS_ROUTE = '/orgs/edr-scan-details'
export const DEEP_SCAN_DETAILS_ROUTE = '/orgs/deep-scan-details'
export const SYSDIAGNOSE_SCAN_DETAILS_ROUTE = '/orgs/sysdiagnose-scan-details'

export const GENERATE_PRESIGNED_URL_ROUTE = '/orgs/generate-presigned-url'
export const MALWARE_THREAT_INTEL_ROUTE = '/orgs/threat-intel/malware'
export const APT_THREAT_INTEL_ROUTE = '/orgs/threat-intel/apt-groups'
export const NETWORK_THREAT_INTEL_ROUTE = '/orgs/threat-intel/network'

export const RESET_DEMO_ACCOUNT_ROUTE = '/orgs/reset-demo-account'
export const TRAVEL_POLICY_ROUTE = '/orgs/travel-policy'
export const ALL_TRAVEL_POLICY_ROUTE = '/orgs/all-travel-policies'
export const TRAVEL_POLICY_WITH_ID_ROUTE = '/orgs/travel-policy-with-id'
export const TRAVEL_MEMBERS_ROUTE = '/orgs/travel-policy/member-list'
export const TRAVEL_LOCATIONS_ROUTE = '/orgs/travel-policy/map'
export const TRAVEL_EVENTS_ROUTE = '/orgs/travel-events'

export const CHECK_IF_ORG_HAS_DEMO_DATA_ROUTE = '/orgs/seed-data-check'
export const REMOVE_DEMO_DATA_ROUTE = '/orgs/remove-seed-org-data'

export const USER_GROUPS_ROUTE = '/orgs/user-groups'
export const POLICY_USER_GROUPS_ROUTE = '/orgs/policy-user-groups'
export const UPDATE_GROUPS_FOR_POLICIES_ROUTE = '/orgs/update-groups-for-policies'
export const USER_GROUP_ROUTE = '/orgs/user-group'
export const MEMBERS_FOR_USER_GROUP_ROUTE = '/orgs/user-group/members'
export const POLICIES_FOR_USER_GROUP_ROUTE = '/orgs/user-group/policies'
export const ALL_POLICIES_FOR_ORG_ROUTE = '/orgs/user-group/org-policies'
export const UPDATE_POLICIES_FOR_GROUP_ROUTE = '/orgs/user-group/update-policies'

export const DEFAULT_PAGE = 1
export const DEFAULT_PAGE_SIZE = 50
export const DASH_PAGE_SIZE = 5
export const MAXIMUM_PAGE_SIZE = 100
